export default "__VITE_PUBLIC_ASSET__5dfa20f0__"